<template lang="pug">
.edit-shortcut-campaign(v-loading="loading")
  .edit-shortcut-campaign__header
    .edit-shortcut-campaign__header__left
      el-breadcrumb(
        separator="/"
      )
        el-breadcrumb-item(
          :to="{ path:'/campaign/list' }"
        ) {{ $t('项目列表') }}
        el-breadcrumb-item {{ form.campaign_name }}
    .edit-shortcut-campaign__header__right
      i.iconfont.icon-arrow_left
      el-button(
        type="text"
        @click="$router.push('/campaign/list')"
        style="width: 72px"
      ) {{ $t('返回') }}

  .edit-shortcut-campaign__overview
    .edit-shortcut-campaign__overview__header
      .edit-shortcut-campaign__overview__header__left
        span {{ $t('项目概况') }}
        span ID: {{ this.campaignId  }}
    el-card.edit-shortcut-campaign__overview__content(shadow="always")
      .edit-shortcut-card__title
        span {{ $t('项目信息') }}
          template(v-if="show_edit_btn")
            span(
              v-if="!isEdit"
              @click="isEdit = !lock"
              :class="{ disabled: lock }"
            )
              i.iconfont.icon-bianji(style="font-size: 14px")
            span(
              v-if="isEdit"
              @click="onConfirm('form')"
              style="cursor: pointer"
            )
              i.iconfont.icon-chucun(style="font-size: 14px")
        el-tooltip(
          v-if="showExpressSettingBtn"
          :content="$t('项目信息修改权限')"
          placement="top"
        )
          i.iconfont.icon-suo(
            v-if="formPermission"
            @click="changeFormPermission(false)"
            style="color: #3370d2;font-size: 19px"
            :class="[!allPermission ? 'disabled' : '']"
          )
          i.iconfont.icon-suo-(
            v-if="!formPermission"
            @click="changeFormPermission(true)"
            style="color: #808080;font-size: 19px"
            :class="[!allPermission ? 'disabled' : '']"
          )
      hr.divider
      view-campaign(
        v-if="!isEdit && viewData"
        :data="viewData"
      )
      .edit-shortcut-campaign__form(v-if="isEdit")
        el-form(
          ref="form"
          :model="form"
          :v-model="form"
          :rules="rules"
          label-width="180px"
          :disabled="lock"
        )
          el-form-item.form-item(
            :label="$t('名称')"
            prop="campaign_name"
          )
            el-input(v-model="form.campaign_name")
          el-form-item.form-item(
            label="Function"
            prop="function_type"
          )
            el-select(
              :disabled="isView"
              v-model="form.function_type"
              @change="onChangeFunction"
            )
              el-option(
                v-for="o, i in functionList"
                :key="i"
                :value="o.id"
                :label="o.name"
              )
          el-row.brand-row(
            v-for="(item, index) in form.campaign_brand"
            :key="index"
          )
            el-col.brand-container
              el-form-item(
                :label="$t('品牌类别')"
                :prop="'campaign_brand[' + index + '].brand_category_id'"
                :rules="{required:true,message: $t('请填写品牌类别'),trigger: 'change'}"
              )
                el-select(
                  v-model="item.brand_category_id"
                  :placeholder="$t('请选择品牌类别')",
                  @change="(val) => { onBrandCategoryChange(val, index) }"
                )
                  el-option(
                    v-for="o, i in brandCategorys"
                    :key="i"
                    :value="o.brand_category_id"
                    :label="o.brand_category_name"
                  )
              el-form-item(
                :label="$t('品牌')"
                :prop="'campaign_brand[' + index + '].brand_id'"
                :rules="{required:true,message: $t('请填写品牌'),trigger: 'change'}"
              )
                el-select(
                  v-model="item.brand_id"
                  :placeholder="$t('请选择品牌')"
                )
                  el-option(
                    v-for="o, i in brandLists[index]"
                    :key="i"
                    :value="o.brand_id"
                    :label="o.brand_name"
                    :disabled="shouldDisabledBrand(index, o.brand_id)"
                  )
            el-col(
              v-if="index !== 0"
              :span="3"
            )
              el-button.delete-brand__btn(
                type="text"
                @click="handleDeleteBrand(index)"
              ) {{ $t('删除') }}
          el-form-item.form-item(
            v-if="form.function_type !== 1"
          )
            span(
              :style="{ color: '#00a0e5', cursor: 'pointer' }"
              @click="handleAddBrand"
            ) + {{ $t('添加品类/品牌') }}
          el-form-item.form-item(
            :label="$t('预算')"
            prop="budget"
          )
            vue-numeric(
              style="width: 200px"
              v-model="form.budget"
              :unit="$t('元')"
              :precision="2"
            )
          el-form-item.form-item(
            :label="$t('上线时间')"
            required
          )
            div(style="display: flex")
              el-form-item(
                prop="start_date"
                style="margin-bottom: 0"
              )
                el-date-picker(
                  v-model="form.start_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('开始日期')"
                  :picker-options="startDatePickerOptions"
                  style="width: 100%"
                )
              span(style="margin: 0 10px" class="line") {{ $t('至') }}
              el-form-item(
                prop="end_date"
                style="margin-bottom: 0"
              )
                el-date-picker(
                  v-model="form.end_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('结束日期')"
                  :picker-options="endDatePickerOptions"
                  style="width: 100%"
                )
          el-form-item.form-item(
            :label="$t('KPI')"
            prop="kpi"
          )
            kpi(v-model="form.kpi")
          el-form-item.form-item(
            :label="$t('描述')"
            prop="introduction"
          )
            el-input(
              v-model="form.introduction"
              type="textarea"
              :rows="8"
              style="width: 380px"
            )
  .edit-shortcut-campaign__sub_final_scope
    el-card.edit-shortcut-campaign__sub_final_scope__content(shadow="always")
      .edit-shortcut-card__title
        span {{ $t('Sub SOW概览') }}
        el-button(
          v-if="is_creator"
          style="position: absolute;right: 32px;top: 8px;border-radius: 5px;width: 100px"
          :disabled="!allConfirmPermission"
          @click="onAddSubFinalScope"
        ) {{ $t('+ Sub SOW') }}
      hr.divider
      el-table(
        :data='subFinalScope'
        style="padding: 8px 32px 24px"
      )
        el-table-column(
          prop='sub_final_scope_name',
          :label='$t("名称")',
          align='left',
        )
        el-table-column(
          prop='category_name',
          :label='$t("项目类别")',
          align='left',
        )
        el-table-column(
          :render-header="renderHeader"
          align="left"
          show-overflow-tooltip
        )
          template(slot-scope="scope")
            div(style="display: flex; align-items: center")
              i.iconfont.icon-r(
                v-if="scope.row.is_storage"
                style="color: #3370d2; margin-right: 5px"
              )
              span(
                :class="{ offset: hasOffset(scope.row) }"
                style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
              ) {{scope.row.vendor_name}}
        el-table-column(
          :label='$t("进度")',
          align='left',
        )
          template(slot-scope='scope')
            span {{ $t(PROCESS_STATUS[scope.row.process_status]) }}
        el-table-column(
          :label='$t("操作")',
          align='left',
        )
          template(slot-scope='scope')
            el-button(
              type='text',
              @click='viewSubFinalScope(scope.row.sub_final_scope_id)',
            ) {{ $t('查看') }}
            span.table-divider |
            el-button(
              type='text',
              :disabled="!scope.row.can_delete || !allConfirmPermission"
              @click='deleteSubFinalScope(scope.row.sub_final_scope_id)'
            ) {{ $t('删除') }}
  .edit-shortcut-campaign__sub_final_scope(v-if="showDotRequestList && dotRequest.length !== 0")
    el-card.edit-shortcut-campaign__sub_final_scope__content(shadow="always")
      .edit-shortcut-card__title
        span {{ $t('DOT 概览') }}
      hr.divider
      el-table(
        :data="dotRequest"
        style="padding: 8px 32px 24px"
      )
        el-table-column(
          :label="$t('名称')"
        )
          template(slot-scope="scope")
            span Social Tracking
        el-table-column(
          :label="$t('类型')"
        )
          template(slot-scope="scope")
            span {{ $t(scope.row.business_type_zh) }}
        el-table-column(
          prop="sub_final_scope_name"
          label="Sub SOW"
        )
        el-table-column(
          :label="$t('DOT负责人')"
        )
          template(slot-scope="scope")
            span {{ $t(scope.row.leader_user) }}
        el-table-column(
          :label="$t('进度')"
        )
          template(slot-scope="scope")
            span {{ $t(scope.row.task_name) }}
        el-table-column(
          :label='$t("操作")'
        )
          template(slot-scope='scope')
            el-button(
              type='text'
              @click="handleViewDot(scope.row)"
            ) {{ $t('查看') }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import FooterButton from '@/components/FooterButton'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
import Kpi from '@/components/Kpi'
import ViewCampaign from './ViewCampaign'
import InputWithCommas from '@/components/InputWithCommas'
import { KPIMap, PROCESS_STATUS, checkFix2 } from '@/umcc/constant.js'
import VueNumeric from '@/components/VueNumeric'

const getKpiList = () => {
  return axios.get('/management/subfinal/getKpiList')
}

const ORIGINAL_KPI_TYPE = 1
const CUSTOMIZED_KPI_TYPE = 2

export default {
  components: {
    TitleBar,
    FooterButton,
    Kpi,
    ViewCampaign,
    InputWithCommas,
    VueNumeric
  },
  data () {
    const validateBudget = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入预算')))
      } else if (value <= 0) {
        callback(new Error(this.$t('预算不能为负数或0')))
      } else if (!checkFix2(value)) {
        callback(new Error(this.$t('预算最多为两位小数')))
      } else {
        callback()
      }
    }
    let validateIntro = (rule, value, callback) => {
      if (value.length > 500) {
        callback(new Error(this.$t('描述不多于500字')))
      } else {
        callback()
      }
    }
    return {
      functionList: [
        {
          id: 1,
          name: 'Brand'
        },
        {
          id: 2,
          name: 'EC'
        },
        {
          id: 3,
          name: 'CD'
        }
      ],
      brandLists: [],
      PROCESS_STATUS,
      loading: false,
      isEdit: false,
      viewData: null,
      brandCategorys: [],
      kpiList: [],
      allPermission: null,
      allPermissionId: null,
      allConfirmPermission: true,
      formPermission: null,
      formPermissionId: null,
      is_creator: false,
      show_edit_btn: false,
      form: {
        campaign_brand: [{
          brand_category_id: '',
          brand_id: ''
        }],
        function_type: null,
        campaign_name: '',
        brandCategory: 1,
        brand: '',
        budget: '',
        start_date: '',
        end_date: '',
        kpi: [{
          target: '',
          kpi_id: null,
          kpi_percent: '',
          kpi_name: '',
          kpi_type: 1
        }],
        introduction: ''
      },
      subFinalScope: [],
      rules: {
        campaign_name: [
          { required: true, message: this.$t('请输入项目名称'), trigger: 'blur' }
        ],
        function_type: [
          { required: true, message: this.$t('请输入Function'), trigger: 'change' }
        ],
        start_date: [
          { required: true, message: this.$t('请输入上线开始日期'), trigger: 'change' }
        ],
        end_date: [
          { required: true, message: this.$t('请输入上线截止日期'), trigger: 'change' }
        ],
        kpi: [
          { required: true }
        ],
        budget: [
          { required: true, validator: validateBudget, trigger: 'blur' }
        ],
        introduction: [
          {
            required: false, validator: validateIntro, trigger: 'blur'
          }
        ]
      },
      startDatePickerOptions: {
        disabledDate: (time) => {
          if (this.form.end_date) {
            return time.getTime() > dayjs(this.form.end_date).unix() * 1000
          }
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.form.start_date) {
            return time.getTime() < dayjs(this.form.start_date).unix() * 1000
          }
        }
      },
      dotRequest: [],
      is_participant: false
    }
  },
  computed: {
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    lock () {
      return !this.allConfirmPermission || (this.allConfirmPermission && !this.formPermission)
    },
    showExpressSettingBtn () {
      return this.$store.state.common.user.permissions.includes('Management_Edit_Button_Express')
    },
    showDotRequestList () {
      return this.$store.state.common.user.permissions.includes('Management_Dot_Request_List')
    },
    brands () {
      return this.brandCategorys.length !== 0 ? this.brandCategorys.find(b => b.brand_category_id === this.form.brandCategory).children : []
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    subFinalScopeList () {
      return this.$store.state.campaign.subFinalScopeList
    }
  },
  mounted () {
    this.getList()
    this.getSOWList()
    this.getSwitchInfo()
    this.getDotRequest()
    if (this.showExpressSettingBtn) {
      this.checkParticipant()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isEdit) {
      this.$confirm(this.$t('离开本页面，已更改的信息将不会被保存。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          return next()
        })
        .catch(() => {
          return next(false)
        })
    } else {
      return next()
    }
  },
  methods: {
    shouldDisabledBrand (index, id) {
      const selectedCategoryId = this.form.campaign_brand[index].brand_category_id
      const selectedBrands = this.form.campaign_brand.filter(i => i.brand_category_id === selectedCategoryId)
        .map(v => v.brand_id)
      return selectedBrands.includes(id)
    },
    getSOWList () {
      axios.get('/management/subfinalExpress/getSOWList', {
        params: {
          campaign_id: this.campaignId
        }
      })
        .then((res) => {
          this.subFinalScope = res
        })
    },
    renderHeader (h, { column, $index }) {
      return <span>
        <span style="fontWeight: 400; cursor: pointer; margin-right: 5px">
          {this.$t('供应商')}
        </span>
        <el-tooltip content={this.$t('R 标识核心供应商类型')} placement="top" style="margin-left: '5px'">
          <i class="el-icon-question"/>
        </el-tooltip>
      </span>
    },
    hasOffset (row) {
      if (this.subFinalScope.some(d => d.is_storage) && !row.is_storage) return true
      return false
    },
    onChangeFunction () {
      this.form.campaign_brand = [
        {
          brand_category_id: '',
          brand_id: ''
        }
      ]
    },
    handleDeleteBrand (index) {
      this.form.campaign_brand.splice(index, 1)
    },
    handleAddBrand () {
      this.form.campaign_brand.push({
        brand_category_id: '',
        brand_id: ''
      })
      this.brandLists.push([])
    },
    onBrandCategoryChange (val, index) {
      this.brandLists[index] = this.brandCategorys.find(b => b.brand_category_id === val).children
      // const firstBrand = this.brandLists[index][0]
      // if (firstBrand) {
      //   this.form.campaign_brand[index].brand_id = firstBrand.brand_id
      // }
    },
    getList () {
      this.loading = true
      Promise.all([axios.get('/common/getBrandTreeStructure'), axios.get('/management/subfinal/getKpiList')])
        .then(res => {
          this.brandCategorys = res[0]
          this.form.kpiList = res[1]
          this.getCampaign()
        })
    },
    changeFormPermission (status) {
      if (!this.allPermission) return

      this.formPermission = status
      const params = {
        business_status: [
          {
            id: this.allPermissionId,
            is_edit: this.allConfirmPermission ? 1 : 0
          },
          {
            id: this.formPermissionId,
            is_edit: this.formPermission ? 1 : 0
          }
        ]
      }
      axios
        .post('/common/updateBusinessSetting', format4backend(params))
        .then(() => {
          if (!this.formPermission) {
            this.isEdit = false
          }
          this.$message.success(this.formPermission ? this.$t('项目信息修改权限已开启') : this.$t('项目信息修改权限已关闭'))
        })
    },
    changeAllPermission (status) {
      if (this.is_participant) return
      this.allPermission = status
      if (this.allPermission) {
        this.allConfirmPermission = this.allPermission
        const params = {
          business_status: [
            {
              id: this.allPermissionId,
              is_edit: this.allConfirmPermission ? 1 : 0
            },
            {
              id: this.formPermissionId,
              is_edit: this.formPermission ? 1 : 0
            }
          ]
        }
        axios
          .post('/common/updateBusinessSetting', format4backend(params))
          .then(() => {
            this.$message.success(this.allConfirmPermission ? this.$t('项目整体修改权限已开启') : this.$t('项目整体修改权限已关闭'))
          })
      } else {
        this.$confirm(`<div><p>${this.$t('关闭项目修改权限后，将无法编辑所有项目内容。')}</p><p>(${this.$t('可进入此页面再次打开项目整体修改权限')})</p></div>`, this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            this.allConfirmPermission = this.allPermission
            const params = {
              business_status: [
                {
                  id: this.allPermissionId,
                  is_edit: this.allConfirmPermission ? 1 : 0
                },
                {
                  id: this.formPermissionId,
                  is_edit: this.formPermission ? 1 : 0
                }
              ]
            }
            axios
              .post('/common/updateBusinessSetting', format4backend(params))
              .then(() => {
                this.$message.success(this.allConfirmPermission ? this.$t('项目整体修改权限已开启') : this.$t('项目整体修改权限已关闭'))
                this.isEdit = false
              })
          })
          .catch(() => {
            this.allPermission = this.allConfirmPermission
          })
      }
    },
    getSwitchInfo () {
      axios
        .get('/common/getBusinessSetting', {
          params: {
            business_id: this.campaignId,
            business_type: 1,
            module_type: 1
          }
        })
        .then((res) => {
          this.allPermission = Boolean(res.parent_is_edit)
          this.allConfirmPermission = this.allPermission
          this.formPermission = Boolean(res.is_edit)
          this.formPermissionId = res.id
          this.allPermissionId = res.parent_id
        })
    },
    getBrandTreeStructure () {
      axios
        .get('/common/getBrandTreeStructure')
        .then((res) => {
          this.brandCategorys = res
          this.form.brandCategory = res[0].brand_category_id
          this.form.brand = res[0].children[0].brand_id
        })
    },
    handleSelect (obj, item) {
      item.kpi_id = obj.kpi_id
    },
    async fetchKpiList () {
      try {
        const res = await getKpiList()
        this.form.kpiList = res
      } catch (err) {
        throw new Error(err)
      }
    },
    querySearch (queryString, cb) {
      const tempList = cloneDeep(this.form.kpiList)
      const kpiList = tempList.map(i => {
        i.kpi_name = this.$t(i.kpi_name)
        return i
      })
      let results = queryString ? kpiList.filter(this.createFilter(queryString)) : kpiList
      cb(results)
    },
    createFilter (queryString) {
      return obj => {
        return (obj.kpi_name.indexOf(queryString) === 0)
      }
    },
    submit () {
      this.$confirm(this.$t('项目信息已修改，确认吗？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          this.loading = true
          const params = {
            campaign: {
              campaign_name: this.form.campaign_name,
              budget: Number(this.form.budget),
              start_date: this.form.start_date,
              end_date: this.form.end_date,
              introduction: this.form.introduction,
              function_type: this.form.function_type
            },
            campaign_brand: this.form.campaign_brand.map(i => {
              return {
                brand_id: i.brand_id,
                brand_category_id: i.brand_category_id
              }
            }),
            campaign_kpi: this.form.kpi.filter(m => m.kpi_type === ORIGINAL_KPI_TYPE).map(n => {
              return {
                kpi_id: n.kpi_id,
                target: n.target,
                kpi_percent: n.kpi_percent
              }
            }).concat(this.form.kpi.filter(m => m.kpi_type === CUSTOMIZED_KPI_TYPE).map(n => {
              return {
                target: n.target,
                kpi_percent: n.kpi_percent
              }
            })),
            kpi: this.form.kpi.filter(m => m.kpi_type === ORIGINAL_KPI_TYPE).map(o => {
              return [{}]
            }).concat(this.form.kpi.filter(m => m.kpi_type === CUSTOMIZED_KPI_TYPE).map(o => {
              return [{
                kpi_name: o.kpi_name,
                unit: o.unit
              }]
            }))
          }

          let apiPath
          apiPath = '/management/campaignExpress/updateExpressCampaign'
          params.campaign.campaign_id = this.$store.state.campaign.id
          axios
            .post(apiPath, format4backend(params))
            .then((res) => {
              this.loading = false
              this.$message.success(this.$t('编辑快捷项目成功'))
              this.getCampaign()
              this.isEdit = false
            })
            .catch(() => {
              this.loading = false
            })
        })
    },
    cancel () {
      this.$router.go(-1)
    },
    async onConfirm (formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (this.form.kpi.some(k => k.kpi_type === ORIGINAL_KPI_TYPE && k.kpi_id == null)) {
          this.loading = false
          this.$message.error(this.$t('请选择KPI'))
          return
        }
        const total = this.form.kpi.reduce((sum, item) => {
          return sum + Number(item.kpi_percent)
        }, 0) || 0
        if (total !== 100) {
          this.loading = false
          return
        }
        const kpiValidateArray = this.form.kpi.map(k => {
          if (!Number.isInteger(Number(k.kpi_percent))) return false
          if (k.kpi_type === CUSTOMIZED_KPI_TYPE) {
            return checkFix2(k.target)
          } else {
            const kpiObject = KPIMap.find(kpi => k.kpi_id === kpi.kpiId)
            return kpiObject.validate(k.target)
          }
        })

        if (kpiValidateArray.some(result => !result)) {
          this.loading = false
          return
        }

        if (!valid) {
          this.loading = false
          return
        }
        this.loading = false
        this.submit()
      })
    },
    viewSubFinalScope (id) {
      this.$store.commit('campaign/setIsNewSubFinalScope', false)
      this.$store.commit('campaign/setSubFinalScopeId', id)
      this.$router.push('/shortcut/category?role=unilever')
    },
    deleteSubFinalScope (id) {
      this.$confirm(this.$t('是否删除当前Sub SOW？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          axios
            .get('/management/subfinalExpress/deleteSubFinalScope', {
              params: {
                sub_final_scope_id: id
              }
            })
            .then(() => {
              this.$message.success(this.$t('删除Sub SOW成功'))
              this.getSOWList()
            })
        })
        .catch(() => {

        })
    },
    getCampaign () {
      this.loading = true
      axios
        .get('/management/campaignExpress/getExpressCampaignInfo', {
          params: {
            campaign_id: this.$store.state.campaign.id
          }
        })
        .then((res) => {
          this.brandLists = res.brand.map(i => {
            return this.brandCategorys.find(o => o.brand_category_id === i.brand_category_id).children
          })
          this.form.kpi = res.kpi.map(i => {
            i.kpi_name = this.$t(i.kpi_name)
            return i
          })
          this.is_creator = this.$store.state.common.user.user_id === res.create_user_id
          this.show_edit_btn = res.is_edit && this.is_creator
          this.form.function_type = res.function_type
          this.form.campaign_name = res.campaign_name
          this.form.campaign_brand = res.brand
          // this.form.brandCategory = res.brand_category_id
          // this.form.brand = res.brand_id
          this.form.budget = res.budget
          this.form.start_date = res.start_date
          this.form.end_date = res.end_date
          this.form.introduction = res.introduction ? res.introduction : ''
          this.viewData = this.form
          this.viewData.brand_category_name = this.brandCategorys.find(c => c.brand_category_id === this.viewData.brandCategory).brand_category_name
          this.viewData.brand_name = this.viewData.brand ? this.brands.find(b => b.brand_id === this.viewData.brand).brand_name : null
          this.loading = false
        })
    },
    onAddSubFinalScope () {
      if (!this.allPermission) return
      this.$router.push('/shortcut/category?role=unilever')
      this.subFinalScopeList.push({
        id: null,
        name: this.$t('Sub SOW') + ' ' + (this.subFinalScopeList.length + 1)
      })
      this.$store.commit('campaign/setSubFinalScopeList', this.subFinalScopeList)
      this.$store.commit('campaign/setIsNewSubFinalScope', true)
      this.$store.commit('campaign/setSubFinalScopeId', null)
      const subFinalScope = {
        business_type: null,
        campaign_id: this.campaignId,
        category: [],
        create_datetime: '',
        kpi: [],
        plan_path: null,
        remark: null,
        report_path: null,
        signature_path: null,
        spotplan_path: null,
        sub_final_scope_id: null,
        sub_final_scope_name: '',
        user_id: null,
        spotplan_name_list: [],
        is_storage: null
      }
      this.$store.commit('campaign/setSubFinalScopeInfo', subFinalScope)
    },
    async getDotRequest () {
      try {
        this.dotRequest = await axios.get('/management/subfinalExpress/getDotRequests', {
          params: {
            campaign_id: this.campaignId
          }
        })
      } catch (err) {
        throw new Error(err)
      }
    },
    handleViewDot (row) {
      this.$store.commit('campaign/setDotPhaseType', row.phase_type)
      this.$store.commit('campaign/setDotBusinessType', row.business_type)
      this.$store.commit('campaign/setDotSubFinalScopeId', row.sub_final_scope_id)
      this.$store.commit('campaign/setSubFinalScopeId', row.sub_final_scope_id)
      this.getSubFinalScopeInfo(row.sub_final_scope_id)
      this.$router.push('/shortcut/dot/social-tracking')
    },
    async getSubFinalScopeInfo (id) {
      try {
        this.subFinalScopeInfo = await axios.get('/management/subfinalExpress/getSubFinalScope', {
          params: {
            sub_final_scope_id: id
          }
        })
        this.$store.commit('campaign/setSubFinalScopeInfo', this.subFinalScopeInfo)
      } catch (err) {
        throw new Error(err)
      }
    },
    checkParticipant () {
      axios.get('/management/campaign/checkParticipant')
        .then(res => {
          this.is_participant = res.is_participant
        })
    }
  }
}
</script>

<style lang="stylus">
.mr-15
  margin-right 15px

.edit-shortcut-campaign
  .iconDisabled
    cursor: not-allowed
  .iconActive
    cursor: pointer
  .el-card__body
    padding 0 !important
  .el-table
    th
      &:nth-child(1)
        padding-left: 14px
      &:last-child
        padding-right: 14px
    tbody
      tr
        td
          &:nth-child(1)
            padding-left: 14px
          &:last-child
            padding-right: 14px
.edit-shortcut-campaign__header
  font-size: 14px
  display: flex
  justify-content space-between
  margin-bottom 17px

.edit-shortcut-campaign__header__left
  color $highlight-font
  display: flex
  align-items center
  .slash
    margin 5px

.edit-shortcut-campaign__all-permission
  padding 0 20px 20px
  > span
    margin-right 15px
.edit-shortcut-campaign__overview
  border #e3e7ed
  border-radius 4px
  margin-bottom 32px

.edit-shortcut-campaign__overview__header
  display: flex
  justify-content space-between
  align-items center
  margin-bottom 16px

.edit-shortcut-campaign__overview__header__left
  font-size 18px
  > span:nth-child(2)
    margin-left 15px
    font-size 14px

.edit-shortcut-campaign__overview__header__right
  display flex
  > span
    display: flex
    align-items center
    margin-right 10px
  .disabled
    cursor not-allowed !important

/*.edit-shortcut-campaign__overview__content*/
  /*p*/
    /*display flex*/
    /*justify-content flex-end*/
    /*margin 0*/

.edit-shortcut-campaign__form
  padding 20px 20px
  width 900px
  .el-input
    width 200px
  .el-select
    width 200px
  .footer-button
    padding-top 20px
    padding-left 150px
  .el-checkbox__label,.el-form-item__content,.el-radio__label
    font-size 12px
  .brand-container
    width 422px
    padding 20px 20px 0 20px
    border 1px dashed #ccc
    box-sizing border-box
    .el-form-item
      .el-form-item__label
        width 160px
      .el-form-item__content
        width 220px
  .form-item
    padding-left 20px
    .el-form-item__label
      width 150px

  .delete-brand__btn
    margin-top 70px
    color red
    margin-left 10px
.edit-shortcut-campaign__sub_final_scope
  margin-bottom 32px
  span.table-divider
    margin 0 5px

.edit-shortcut-campaign__sub_final_scope__header
  display flex
  justify-content space-between
  align-items center
  margin-bottom 20px

.edit-shortcut-campaign__sub_final_scope__header__left
  font-size 18px

.edit-shortcut-campaign__sub_final_scope__header__right
  > div
    width: 153px
    height: 40px
    border-radius: 4px
    background-image: linear-gradient(to left, #6fa7ba, #61a8eb 34%, #3370d2)
    display: flex
    justify-content: center
    align-items: center
    font-size: 16px
    color: #fff
    font-weight: 600
    cursor: pointer
  > .disabled
    color: #808080
    background-image: none
    background-color: #eeeeee
    cursor: not-allowed
.edit-shortcut-card__title
  .disabled
    color: #808080
    cursor: not-allowed
    i
      cursor not-allowed
.iconfont
  cursor pointer
  font-size 19px
.iconfont.disabled
  cursor not-allowed
  color #808080 !important
.edit-shortcut-campaign__header__right
  display flex
  align-items center
  i
    color $main
    margin-right: -2px;
  .el-button
    padding-top 8px
    width auto !important
.edit-shortcut-card__title
  padding 16px 32px 0
  display flex
  position relative
  justify-content space-between
  > span
    color #2c3031
    font-size 16px
    line-height normal
    span
      font-size 12px
      color $main
      margin-left 11px
.divider
  display block
  border 0
  border-top 1px solid #ebebeb
  padding 0
</style>
